export function phoneSelector(state) {
  return state.view.data.phone;
}
export function loginSelector(state) {
  return state.login;
}